module.exports = __webpack_public_path__ + "img/symbol_1.3e422b16.png";